import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ErrorResponse,
  RemoveUserResponse,
  removeUserResponseSchema,
} from '../../../common/validations'

import { post } from 'api/apiClient'

export const useAPIRemoveUser = (
  options?: UseMutationOptions<RemoveUserResponse, ErrorResponse>
) =>
  useMutation({
    mutationFn: () =>
      post(API_ENDPOINTS.REMOVE_USER, {}, removeUserResponseSchema),
    ...options,
  })
